module.exports = __webpack_public_path__ + "media/1x1/tg-29fa137c.svg";